// src/ReviewSection.js
import React from 'react';
import ReviewCard from './ReviewCard';

// The data has been updated with a new review.
const reviews = [
    {
        id: 1,
        name: 'Kevin Kolbe',
        title: 'Creator',
        type: 'video',
        imageUrl: 'https://i.imgur.com/LOfv2S8.jpeg',
        videoUrl: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
    },
    {
        id: 2,
        name: 'Kirk Lowe',
        title: 'CEO @ ProudMouth',
        rating: 5,
        text: 'Amazing tool. Coming of age for video testimonials and community.',
        imageUrl: 'https://i.imgur.com/rS2InwB.jpeg',
    },
    {
        id: 3,
        name: 'Mike Hendrix',
        title: 'Vice President at Teesnap',
        rating: 4,
        text: "Can't remember the last time we rolled out new technology to a team that was met with such positivity.",
        imageUrl: 'https://i.imgur.com/8Qtm9cW.jpeg',
    },
    {
        id: 4,
        name: 'Justin Welsh',
        title: 'The Diversified Solopreneur',
        rating: 4,
        text: 'StoryPrompt offers an intuitive and streamlined approach to collecting and showcasing video testimonials. A user-friendly interface simplifies collecting and managing testimonials, while guided prompts help customers create engaging and authentic feedback.',
        imageUrl: 'https://i.imgur.com/k2ANyEe.jpeg',
    },
    {
        id: 5,
        name: 'Marci Goodwin',
        title: 'I help communities develop & grow small business ecosystems',
        rating: 5,
        text: 'The Wall of Love feature is fantastic! I am working on gathering content to create our wall!',
        imageUrl: 'https://i.imgur.com/cIexiW9.jpeg',
    },
    {
        id: 6,
        name: 'Aaron Montgomery',
        title: 'CEO, Our Success Group',
        type: 'video',
        imageUrl: 'https://i.imgur.com/sETiM0w.jpeg',
        videoUrl: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
    },
    {
        id: 7,
        name: 'Gear Up Consulting',
        title: '242 followers',
        rating: 5,
        text: 'Thank you to StoryPrompt who provides this amazing platform and software.',
        imageUrl: 'https://i.imgur.com/s6fL3gR.png',
        isLogo: true,
    },
    {
        id: 8,
        name: 'Park Howell',
        title: 'Business of Story',
        type: 'video-testimonial',
        imageUrl: 'https://i.imgur.com/kPOnk2d.jpeg',
        videoUrl: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4',
    },
    {
        id: 9,
        name: 'Pat Miller',
        title: 'Syndicated Radio Host & Small Business Community Builder',
        rating: 5,
        text: "This is an INCREDIBLE feature. It allows you to showcase your impact in the words and video of your customers. It's really made our homepage come to life. Thank you StoryPrompt!",
        imageUrl: 'https://i.imgur.com/8Qtm9cW.jpeg'
    },
    {
        id: 10,
        name: 'Bill Quell',
        title: 'Founder, ClickAwayMarketing',
        rating: 5,
        text: '❤️ what you guys are building...and THANK YOU for the t-shirt!',
        imageUrl: 'https://i.imgur.com/4zITm6T.jpeg'
    },
    {
        id: 11,
        name: 'Tarja Teppo',
        text: 'Check out the video I just made with StoryPrompt (this is not a paid ad, but I love discovering new ways to reach out to people)! https://storyprompt.com/reply/EkXTwu1N9BUBSfhWjxSz',
        imageUrl: 'https://i.imgur.com/cIexiW9.jpeg',
        isLink: true
    },
    // New review added here
    {
        id: 12,
        name: 'Alex Rivera',
        title: 'Digital Marketer',
        rating: 5,
        text: 'A seamless experience from start to finish. The platform is incredibly user-friendly and has helped us build a powerful wall of social proof.',
        imageUrl: 'https://i.imgur.com/k6Qle5W.png'
    },
];

function ReviewSection() {
    return (
        <>
         <div className="story-wall-container">
         <div className="review-section-header">
                <h2>Some Of Our Clients<br />Saying About Us</h2>
            </div>
       
            {/* ——— Section title ——— */}

            <div className="story-wall-grid">
                {reviews.map(review => (
                    <ReviewCard key={review.id} review={review} />
                ))}
            </div>
        </div>
    </>
    );
}

export default ReviewSection;